import { ROUTES } from '@/shared/routes';

export const GALLERY_OVERVIEW_PATH = '/gallery';
const OVERVIEW_PATH = GALLERY_OVERVIEW_PATH;

export interface NavItem {
  label: string;
  path: string;
  /** Item shows only when the account's scopes allow this API route. */
  canCall?: [method: string, path: string];
  /** Item shows only when the account holds this permission. */
  permission?: string;
  /** Item shows when the account holds at least one of these permissions. */
  anyPermission?: string[];
  /** Item shows only when the account lacks this permission. */
  withoutPermission?: string;
}

export const DASHBOARD_ITEMS: NavItem[] = [
  { label: 'Overview', path: '/dashboard' },
  { label: 'My Artworks', path: '/dashboard/artworks' },
  { label: 'Profile', path: '/dashboard/profile' },
  { label: 'Security', path: ROUTES.accountSecurity },
  {
    label: 'Writer keys',
    path: '/account/writer-keys',
    permission: 'cards.write-tags',
  },
  { label: 'Sales', path: '/dashboard/sales' },
  { label: 'Purchases', path: '/dashboard/purchases' },
];

export const ADMIN_ITEMS: NavItem[] = [
  {
    label: 'Admin Overview',
    path: '/admin',
    canCall: ['GET', '/v1/art/admin/stats'],
  },
  {
    label: 'Passport Requests',
    path: '/admin/requests',
    canCall: ['GET', '/v1/art/admin/requests'],
  },
  {
    label: 'Passport orders',
    path: '/admin/passport-orders',
    permission: 'passports.fulfill',
  },
  {
    label: 'NFC tags',
    path: '/admin/tags',
    anyPermission: ['passports.fulfill', 'cards.utilize'],
  },
  {
    label: 'Profile reviews',
    path: '/admin/profile-reviews',
    permission: 'accounts.review-profiles',
  },
  {
    label: 'Galleries',
    path: '/admin/galleries',
    canCall: ['GET', '/v1/art/admin/galleries/'],
  },
  {
    label: 'Provenance review',
    path: '/admin/provenance-proposals',
    permission: 'provenance.review',
  },
  {
    label: 'Artwork changes',
    path: '/admin/artwork-changes',
    permission: 'artworks.review-changes',
  },
  {
    label: 'Users',
    path: '/admin/users',
    canCall: ['GET', '/v1/art/admin/accounts'],
  },
  { label: 'Roles', path: '/admin/roles', permission: 'roles.manage' },
  {
    label: 'Notifications',
    path: '/admin/notifications',
    permission: 'notifications.broadcast',
  },
  {
    label: 'Transfers',
    path: '/admin/transfers',
    canCall: ['GET', '/v1/art/admin/transfers'],
  },
  {
    label: 'Escrow',
    path: '/admin/escrow',
    permission: 'escrow.manage',
  },
  {
    label: 'Pages',
    path: '/admin/pages',
    permission: 'content.manage',
  },
];

export const GALLERY_ITEMS: NavItem[] = [
  { label: 'Overview', path: OVERVIEW_PATH },
  {
    label: 'Artworks',
    path: '/gallery/artworks',
    permission: 'gallery-artworks.create',
  },
  {
    label: 'Full provenance',
    path: '/gallery/provenance',
    permission: 'provenance.view-full',
  },
  {
    label: 'Subscription',
    path: '/gallery/subscription',
    permission: 'gallery-subscription.manage',
  },
  {
    label: 'API tokens',
    path: '/gallery/api-tokens',
    permission: 'public-api.use',
  },
  {
    label: 'Apply',
    path: '/gallery/apply',
    withoutPermission: 'gallery-artworks.create',
  },
  { label: 'Security', path: ROUTES.accountSecurity },
];
